export default __webpack_public_path__ + "static/media/truthtake2.4bd9b88c.mp3";